import { Stack, Typography } from "@mui/material";
import { ContainedButtonWithForwardArrow } from "react-common-ui-library";
import { useIntl } from "react-intl";
import {
  ADMIN_DASHBOARD_ROUTE,
  CONTAINED,
  H1,
  H3,
  PROVIDER_ADMIN_ROUTE,
  P_REGULAR,
  SECONDARY_MAIN,
  SUPER_ADMIN,
} from "../../../Constants/CommonConstants";
import { navigateToFpactPage } from "../../../Services/CommonServices";
import { StyledLinkApplicationSubmitButtonBox } from "../../../Styles/LinkApplication/LinkMyApplication";
import {
  LEGAL_NOTICE_BUTTON,
  LEGAL_NOTICE_BUTTON_ID,
  LEGAL_NOTICE_HEADING,
  LEGAL_NOTICE_TEXT_ONE,
  LEGAL_NOTICE_TEXT_THREE,
  LEGAL_NOTICE_TEXT_TWO,
} from "./LegalNoticeConstants";
import { useSelector } from "react-redux";
import { manageAuthorizationSelector } from "../../../Selectors/AuthorizationSelector";

/**
 * @description Legal Notice screen allows the user view and comply to the legal notice
 * @returns {ReactNode} Renders the heading, subtext and a Button
 */
export const LegalNotice = () => {
  const intl = useIntl();
  const { scopes } = useSelector((state) => manageAuthorizationSelector(state));

  const onContinueClickHandler = () => {
    if (scopes === SUPER_ADMIN) {
      navigateToFpactPage(PROVIDER_ADMIN_ROUTE, ADMIN_DASHBOARD_ROUTE);
    } else {
      navigateToFpactPage(PROVIDER_ADMIN_ROUTE);
    }
  };

  return (
    <Stack spacing={{ xs: 5, md: 6 }}>
      <Typography
        component={H1}
        variant={H3}
        color={SECONDARY_MAIN}
        id={LEGAL_NOTICE_HEADING}
      >
        {intl.formatMessage({ id: LEGAL_NOTICE_HEADING })}
      </Typography>
      <Stack spacing={3}>
        <Typography variant={P_REGULAR} id={LEGAL_NOTICE_TEXT_ONE}>
          {intl.formatMessage({ id: LEGAL_NOTICE_TEXT_ONE })}
        </Typography>
        <Stack spacing={3}>
          <Typography variant={P_REGULAR} id={LEGAL_NOTICE_TEXT_TWO}>
            {intl.formatMessage({ id: LEGAL_NOTICE_TEXT_TWO })}
          </Typography>
          <Stack spacing={10}>
            <Typography variant={P_REGULAR} id={LEGAL_NOTICE_TEXT_THREE}>
              {intl.formatMessage({ id: LEGAL_NOTICE_TEXT_THREE })}
            </Typography>
            <StyledLinkApplicationSubmitButtonBox>
              <ContainedButtonWithForwardArrow
                onClick={onContinueClickHandler}
                variant={CONTAINED}
                id={LEGAL_NOTICE_BUTTON_ID}
              >
                {intl.formatMessage({ id: LEGAL_NOTICE_BUTTON })}
              </ContainedButtonWithForwardArrow>
            </StyledLinkApplicationSubmitButtonBox>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default LegalNotice;
